export const fmt = {
  currency: (v) => `$${Number(v || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
  number:   (v) => Number(v || 0).toLocaleString('en-US'),
  pct:      (v) => `${Number(v || 0).toFixed(1)}%`,
  date:     (v) => v ? new Date(v).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : '—',
  dateTime: (v) => v ? new Date(v).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' }) : '—',
  qty:      (v, uom) => `${Number(v || 0).toLocaleString()} ${uom || ''}`.trim(),
};

export function statusBadgeClass(status) {
  const map = {
    ok: 'badge-ok', good: 'badge-ok', fulfilled: 'badge-ok', complete: 'badge-ok',
    received: 'badge-ok', active: 'badge-ok', success: 'badge-ok', processed: 'badge-ok',
    low: 'badge-amber', warning: 'badge-amber', pending: 'badge-amber', partial: 'badge-amber',
    in_progress: 'badge-blue', sent: 'badge-blue', planned: 'badge-blue',
    processing: 'badge-blue', pending_approval: 'badge-amber',
    critical: 'badge-crit', backordered: 'badge-crit', open: 'badge-amber',
    cancelled: 'badge-gray', rejected: 'badge-gray', deactivated: 'badge-gray',
    draft: 'badge-gray', error: 'badge-crit',
  };
  return map[status?.toLowerCase()] || 'badge-gray';
}

export function daysOfCoverClass(days) {
  if (days === null || days === undefined) return 'badge-gray';
  if (days >= 30) return 'badge-ok';
  if (days >= 14) return 'badge-amber';
  return 'badge-crit';
}

export function errMsg(err) {
  return err?.response?.data?.error || err?.response?.data?.message || err?.message || 'An error occurred';
}
